<section class="section banner" id="banner">
    <div class="container-fluid p-0" data-aos="fade-up" data-aos-duration="1000">
        <div class="row no-gutters position-relative">
            <div class="col-12 position-relative photos-container">
                <!-- Second photo -->
                <img [src]="language === 'en' ? 'assets/images/Aspire_en.jpeg' : 'assets/images/Aspire_ar.jpeg'" class="img-fluid w-100 second-photo empty-space"
                    alt="Second Photo">

                <!-- First photo -->
                <!-- <img *ngIf="language=='ar'" src="assets/images/banner_aspire_ar.jpeg" class="img-fluid w-100" alt="First Photo"> -->
                <!-- <img *ngIf="language=='en'" src="assets/images/banner_aspire_en.jpeg" class="img-fluid w-100" alt="First Photo"> -->

                <picture *ngIf="language=='ar'">
                    <source media="(min-width: 576px)" srcset="assets/images/banner_aspire_ar.jpeg">
                    <source media="(min-width: 300px)" srcset="assets/images/arabic download.png">
                    <img src="assets/images/arabic download.png" alt="IfItDoesntMatchAnyMedia">
                </picture>
                <picture *ngIf="language=='en'">
                    <source media="(min-width: 576px)" srcset="assets/images/banner_aspire_en.jpeg">
                    <source media="(min-width: 300px)" srcset="assets/images/english download.png">
                    <img src="assets/images/english download.png" alt="IfItDoesntMatchAnyMedia">
                </picture>

                <div class="clickable-photo-container">
                    <a href="https://apps.apple.com/eg/app/pioneers-go/id6739808913" class="clickable-photo mb-2"
                        target="_blank" rel="noopener noreferrer">
                        <img *ngIf="language=='en'" src="assets/images/app-store.png" class="clickable-photo-img"
                            alt="App Store">
                        <img *ngIf="language=='ar'" src="assets/images/ar-appstore-dark.svg" class="clickable-photo-img"
                            alt="App Store">
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.fitoman.piogo&hl=en"
                        class="clickable-photo mb-2" target="_blank" rel="noopener noreferrer">
                        <img *ngIf="language=='en'" src="assets/images/google-play.png" class="clickable-photo-img"
                            alt="Google Play">
                        <img *ngIf="language=='ar'" src="assets/images/ar-gplay-dark.svg" class="clickable-photo-img"
                            alt="Google Play">
                    </a>
                </div>
                <picture *ngIf="language=='ar'">
                    <source media="(min-width: 576px)" srcset="assets/images/employees_ar.png">
                    <source media="(min-width: 300px)" srcset="assets/images/arabic.png">
                    <img src="assets/images/arabic.png" alt="IfItDoesntMatchAnyMedia">
                </picture>
                <picture *ngIf="language=='en'">
                    <source media="(min-width: 576px)" srcset="assets/images/employees_en.png">
                    <source media="(min-width: 300px)" srcset="assets/images/english.png">
                    <img src="assets/images/english.png" alt="IfItDoesntMatchAnyMedia">
                </picture>


                <!-- Employee image -->
                <!-- <img *ngIf="language=='ar'" src="assets/images/employees_ar.png" class="img-fluid w-100" alt="First Photo"> -->
                <!-- <img *ngIf="language=='en'" src="assets/images/employees_en.png" class="img-fluid w-100" alt="First Photo"> -->
            </div>
        </div>
    </div>
</section>